export default __webpack_public_path__ + "static/media/img-26-dewin.fc5a6d87.jpg";